import { IWbUserInfo } from '@interco/inter-webview-bridge'

export const shouldInsertAccount = ({
  account,
}: {
  accountType: AccountType
  account: string
}) => ({
  ...{
    'x-inter-conta-corrente': account,
  },
})

export const getUserSsn = (user?: IWbUserInfo, accountType?: AccountType): string => {
  if (accountType === 'PJ') {
    const currentAccount = user?.bankAccountList?.find((account) => account.current)
    return currentAccount?.cpfCnpj || ''
  }

  return user?.cpf || ''
}
